import React from "react";
import { Link } from "react-router-dom";
import { conciergeServices } from "../../data/conciergeServices";

const Card = () => {
  return (
    <section className="max-w-[1400px] mx-auto px-6 py-28">
      <div className="max-w-[850px] mx-auto text-center mb-20">
        <h2
          className="text-[55px] leading-tight text-[#0F172A]"
          style={{ fontFamily: "Pochaevsk" }}
        >
          Our Concierge Services
        </h2>

        <p
          className="text-[17px] text-gray-500 mt-6 leading-8"
          style={{ fontFamily: "Poppins" }}
        >
          From legal assistance and mortgage support to relocation and lifestyle
          management, Benzies Estate provides a complete range of personalized
          services designed to make your experience in Spain seamless and
          stress-free.
        </p>
      </div>

      <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-8">
        {conciergeServices.map((item, index) => (
          <Link
            key={index}
            to={item.link}
            className="group block bg-white rounded-[30px] overflow-hidden border border-gray-100 shadow-lg hover:-translate-y-3 duration-500 hover:shadow-2xl"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-[240px] object-cover"
            />

            <div className="p-8">
              <h3
                className="text-[28px] text-[#111827] mb-5"
                style={{ fontFamily: "Pochaevsk" }}
              >
                {item.title}
              </h3>

              <p
                className="text-gray-500 leading-8 text-[15px] mb-6"
                style={{ fontFamily: "Poppins" }}
              >
                {item.description}
              </p>

              <span
                className="font-semibold text-[#B68A35] group-hover:tracking-wide duration-300 inline-block"
                style={{ fontFamily: "Poppins" }}
              >
                Learn More →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Card;